export const personalityTypes = {
  A: { number: 9, group: 'visceral', color: 'red' },
  B: { number: 6, group: 'mental', color: 'blue' },
  C: { number: 3, group: 'emocional', color: 'green' },
  D: { number: 1, group: 'visceral', color: 'red' },
  E: { number: 4, group: 'emocional', color: 'green' },
  F: { number: 2, group: 'emocional', color: 'green' },
  G: { number: 8, group: 'visceral', color: 'red' },
  H: { number: 5, group: 'mental', color: 'blue' },
  I: { number: 7, group: 'mental', color: 'blue' }
};

export const questions = [
  {
    id: 1,
    question: "Por lo general he sido una persona…",
    interpretations: [
      { id: 'a', text: "Romántica e imaginativa", value: 'E' },
      { id: 'b', text: "Pragmática y con los pies en la tierra", value: 'B' }
    ]
  },
  {
    id: 2,
    question: "Sobre todo me he inclinado a…",
    interpretations: [
      { id: 'a', text: "La confrontación", value: 'G' },
      { id: 'b', text: "Evitar la confrontación", value: 'A' }
    ]
  },
  {
    id: 3,
    question: "Típicamente he sido una persona…",
    interpretations: [
      { id: 'a', text: "Diplomática, encantadora y ambiciosa", value: 'C' },
      { id: 'b', text: "Directa, formal e idealista", value: 'D' }
    ]
  },
  {
    id: 4,
    question: "Sobre todo me he inclinado a ser una persona…",
    interpretations: [
      { id: 'a', text: "Enfocada e intensa", value: 'H' },
      { id: 'b', text: "Espontánea y divertida", value: 'I' }
    ]
  },
  {
    id: 5,
    question: "Por lo general he sido una persona…",
    interpretations: [
      { id: 'a', text: "Hospitalaria y he disfrutado de dar la bienvenida a nuevos amigos en mi vida", value: 'F' },
      { id: 'b', text: "Privada y no me he mezclado mucho con otros", value: 'E' }
    ]
  },
  {
    id: 6,
    question: "Generalmente es difícil para mí…",
    interpretations: [
      { id: 'a', text: "Relajarme y dejar de pensar en problemas que no han ocurrido", value: 'B' },
      { id: 'b', text: "Preocuparme con problemas que no han ocurrido", value: 'A' }
    ]
  },
  {
    id: 7,
    question: "He sido más…",
    interpretations: [
      { id: 'a', text: "Un(a) sobreviviente astuto(a)", value: 'G' },
      { id: 'b', text: "Un(a) idealista de principios y sentimientos", value: 'D' }
    ]
  },
  {
    id: 8,
    question: "Personalmente…",
    interpretations: [
      { id: 'a', text: "He necesitado mostrar afecto hacia los demás", value: 'F' },
      { id: 'b', text: "He preferido mantenerme a cierta distancia de los demás", value: 'H' }
    ]
  },
  {
    id: 9,
    question: "Cuando se me presenta una nueva experiencia me pregunto si…",
    interpretations: [
      { id: 'a', text: "Me será útil", value: 'C' },
      { id: 'b', text: "Será divertida", value: 'I' }
    ]
  },
  {
    id: 10,
    question: "Me he inclinado más hacia…",
    interpretations: [
      { id: 'a', text: "Mí mismo(a)", value: 'E' },
      { id: 'b', text: "Los demás", value: 'A' }
    ]
  },
  {
    id: 11,
    question: "Las personas dependen de mí por…",
    interpretations: [
      { id: 'a', text: "Mi percepción y conocimiento", value: 'H' },
      { id: 'b', text: "Mi fortaleza y poder de decisión", value: 'G' }
    ]
  },
  {
    id: 12,
    question: "Me veo como una persona…",
    interpretations: [
      { id: 'a', text: "Insegura de mí misma", value: 'B' },
      { id: 'b', text: "Segura de mí misma", value: 'D' }
    ]
  },
  {
    id: 13,
    question: "Me oriento más hacia…",
    interpretations: [
      { id: 'a', text: "Las relaciones interpersonales que al logro de metas", value: 'F' },
      { id: 'b', text: "El logro de metas que a las relaciones interpersonales", value: 'C' }
    ]
  },
  {
    id: 14,
    question: "Generalmente…",
    interpretations: [
      { id: 'a', text: "No he sido capaz de hablar por mí mismo(a)", value: 'E' },
      { id: 'b', text: "He sido abierto(a).  He dicho lo que otros no han tenido el valor de decir", value: 'I' }
    ]
  },
  {
    id: 15,
    question: "Ha sido difícil para mí…",
    interpretations: [
      { id: 'a', text: "Dejar de darle vueltas a mis opciones y tomar una decisión definitiva", value: 'H' },
      { id: 'b', text: "Tomarlo con calma y ser más flexible", value: 'D' }
    ]
  },
  {
    id: 16,
    question: "Tengo tendencia a ser…",
    interpretations: [
      { id: 'a', text: "Cauteloso(a) y a dudar mucho", value: 'B' },
      { id: 'b', text: "Audaz y dominante", value: 'G' }
    ]
  },
  {
    id: 17,
    question: "He tenido problemas con la gente por…",
    interpretations: [
      { id: 'a', text: "Mi resistencia a involucrarme demasiado", value: 'A' },
      { id: 'b', text: "Mi afán para que dependan de mí", value: 'F' }
    ]
  },
  {
    id: 18,
    question: "Normalmente he…",
    interpretations: [
      { id: 'a', text: "Apartado mis sentimientos para terminar mi trabajo", value: 'C' },
      { id: 'b', text: "Priorizado mis sentimientos antes de actuar", value: 'E' }
    ]
  },
  {
    id: 19,
    question: "Por lo general soy una persona…",
    interpretations: [
      { id: 'a', text: "Metódica y precavida", value: 'B' },
      { id: 'b', text: "Aventurera y de tomar riesgos", value: 'I' }
    ]
  },
  {
    id: 20,
    question: "Tengo tendencia a ser una persona…",
    interpretations: [
      { id: 'a', text: "Solidaria y generosa que disfruta de la compañía de otros", value: 'F' },
      { id: 'b', text: "Seria y reservada que le gusta discutir sobre temas", value: 'D' }
    ]
  },
  {
    id: 21,
    question: "Con frecuencia siento la necesidad de…",
    interpretations: [
      { id: 'a', text: "Ser un pilar de fortaleza", value: 'G' },
      { id: 'b', text: "Desempeñarme a la perfección", value: 'C' }
    ]
  },
  {
    id: 22,
    question: "Me intereso más por…",
    interpretations: [
      { id: 'a', text: "Las preguntas difíciles y por mantener mi independencia", value: 'H' },
      { id: 'b', text: "Conservar mi estabilidad y mi paz mental", value: 'A' }
    ]
  },
  {
    id: 23,
    question: "He sido una persona un poco más…",
    interpretations: [
      { id: 'a', text: "Cínica y escéptica", value: 'B' },
      { id: 'b', text: "Blanda y sentimental", value: 'F' }
    ]
  },
  {
    id: 24,
    question: "Con frecuencia me preocupa que…",
    interpretations: [
      { id: 'a', text: "Me esté perdiendo de algo mejor", value: 'I' },
      { id: 'b', text: "Si bajo la guardia van a aprovecharse de mí", value: 'G' }
    ]
  },
  {
    id: 25,
    question: "Las personas se molestan conmigo por mi hábito de:",
    interpretations: [
      { id: 'a', text: "Distanciarme de ellas", value: 'E' },
      { id: 'b', text: "Decirles lo que tienen que hacer", value: 'D' }
    ]
  },
  {
    id: 26,
    question: "Me he inclinado a sentirme más ansioso(a) cuando me encuentro con situaciones…",
    interpretations: [
      { id: 'a', text: "Muy emocionantes y estimulantes", value: 'A' },
      { id: 'b', text: "No lo suficientemente emocionantes y estimulantes", value: 'I' }
    ]
  },
  {
    id: 27,
    question: "En mis relaciones interpersonales…",
    interpretations: [
      { id: 'a', text: "He dependido de mis amigos y ellos han sabido que pueden depender de mí", value: 'B' },
      { id: 'b', text: "No he dependido de las personas, he hecho las cosas por mí mismo(a)", value: 'C' }
    ]
  },
  {
    id: 28,
    question: "Generalmente me he inclinado a ser una persona…",
    interpretations: [
      { id: 'a', text: "Desconectada de los demás y preocupada", value: 'H' },
      { id: 'b', text: "Temperamental y ensimismada", value: 'E' }
    ]
  },
  {
    id: 29,
    question: "Me ha gustado…",
    interpretations: [
      { id: 'a', text: "Retar y sacudir a las personas", value: 'G' },
      { id: 'b', text: "Reconfortar y calmar a las personas", value: 'F' }
    ]
  },
  {
    id: 30,
    question: "Generalmente he sido una persona…",
    interpretations: [
      { id: 'a', text: "Extrovertida y sociable", value: 'I' },
      { id: 'b', text: "Sería y disciplinada", value: 'D' }
    ]
  },
  {
    id: 31,
    question: "He preferido…",
    interpretations: [
      { id: 'a', text: "No sobresalir en un grupo", value: 'A' },
      { id: 'b', text: "Destacarme en un grupo", value: 'C' }
    ]
  },
  {
    id: 32,
    question: "Para mí ha sido más importante…",
    interpretations: [
      { id: 'a', text: "Perseguir mis intereses personales que tener seguridad y estabilidad", value: 'H' },
      { id: 'b', text: "Tener seguridad y estabilidad que perseguir mis intereses", value: 'B' }
    ]
  },
  {
    id: 33,
    question: "Cuando he tenido conflicto con otras personas…",
    interpretations: [
      { id: 'a', text: "Me he retraído", value: 'E' },
      { id: 'b', text: "Rara vez he dado un paso atrás", value: 'G' }
    ]
  },
  {
    id: 34,
    question: "Me he inclinado por…",
    interpretations: [
      { id: 'a', text: "Rendirme con demasiada facilidad y he dejado que otros me empujen", value: 'A' },
      { id: 'b', text: "Ser demasiado intransigente y exigente con los demás", value: 'D' }
    ]
  },
  {
    id: 35,
    question: "Me han valorado por…",
    interpretations: [
      { id: 'a', text: "Mi espíritu inquebrantable y mi ingenio", value: 'I' },
      { id: 'b', text: "Mi profundo cariño y calidez personal", value: 'F' }
    ]
  },
  {
    id: 36,
    question: "Me he inclinado por…",
    interpretations: [
      { id: 'a', text: "Causar una impresión favorable a los demás", value: 'C' },
      { id: 'b', text: "No importarme dar una impresión favorable a los demás", value: 'H' }
    ]
  },
  {
    id: 37,
    question: "He dependido más de…",
    interpretations: [
      { id: 'a', text: "Mi perseverancia y sentido común", value: 'B' },
      { id: 'b', text: "Mi inspiración e imaginación", value: 'E' }
    ]
  },
  {
    id: 38,
    question: "Básicamente he sido una persona…",
    interpretations: [
      { id: 'a', text: "Tranquila y agradable", value: 'A' },
      { id: 'b', text: "Diligente y asertiva", value: 'G' }
    ]
  },
  {
    id: 39,
    question: "Ser aceptado(a) y querido(a)…",
    interpretations: [
      { id: 'a', text: "Ha sido mi prioridad y he trabajado duro para lograrlo", value: 'C' },
      { id: 'b', text: "No ha sido una prioridad importante para mí", value: 'D' }
    ]
  },
  {
    id: 40,
    question: "Cuando otros me presionan me he inclinado por ser una persona más…",
    interpretations: [
      { id: 'a', text: "Retraída", value: 'H' },
      { id: 'b', text: "Asertiva", value: 'I' }
    ]
  },
  {
    id: 41,
    question: "La gente se ha interesado en mí porque he sido una persona…",
    interpretations: [
      { id: 'a', text: "Extrovertida, atractiva y me intereso por los demás", value: 'F' },
      { id: 'b', text: "Tranquila, inusual y profunda", value: 'E' }
    ]
  },
  {
    id: 42,
    question: "Para mí han sido importantes los valores de…",
    interpretations: [
      { id: 'a', text: "Deber y responsabilidad", value: 'B' },
      { id: 'b', text: "Armonía y aceptación", value: 'A' }
    ]
  },
  {
    id: 43,
    question: "He intentado motivar a las personas…",
    interpretations: [
      { id: 'a', text: "Haciendo grandes planes y promesas", value: 'G' },
      { id: 'b', text: "Señalando las consecuencias por no seguir mis consejos", value: 'D' }
    ]
  },
  {
    id: 44,
    question: "Ser una persona emocionalmente expresiva…",
    interpretations: [
      { id: 'a', text: "Rara vez lo he sido", value: 'H' },
      { id: 'b', text: "A menudo lo he sido", value: 'F' }
    ]
  },
  {
    id: 45,
    question: "Ocuparme de los detalles…",
    interpretations: [
      { id: 'a', text: "No ha sido mi fortaleza", value: 'I' },
      { id: 'b', text: "Me he destacado en ello", value: 'C' }
    ]
  },
  {
    id: 46,
    question: "A menudo he enfatizado…",
    interpretations: [
      { id: 'a', text: "Lo diferente que soy de la mayoría de las personas, especialmente mi familia", value: 'E' },
      { id: 'b', text: "Lo mucho que tengo en común con la mayoría gente, especialmente mi familia", value: 'A' }
    ]
  },
  {
    id: 47,
    question: "En situaciones acaloradas he preferido…",
    interpretations: [
      { id: 'a', text: "Quedarme al margen", value: 'H' },
      { id: 'b', text: "Involucrarme", value: 'G' }
    ]
  },
  {
    id: 48,
    question: "Generalmente con mis amistades…",
    interpretations: [
      { id: 'a', text: "He sido un apoyo a pesar de sus equivocaciones", value: 'B' },
      { id: 'b', text: "No he sacrificado lo que es correcto ni siquiera por la amistad", value: 'D' }
    ]
  },
  {
    id: 49,
    question: "He sido una persona…",
    interpretations: [
      { id: 'a', text: "Que apoya a los demás", value: 'F' },
      { id: 'b', text: "Altamente motivada y con iniciativa", value: 'C' }
    ]
  },
  {
    id: 50,
    question: "Cuando he tenido dificultades…",
    interpretations: [
      { id: 'a', text: "Le he dado muchas vueltas hasta resolverlas", value: 'E' },
      { id: 'b', text: "Me he inclinado a distraerme", value: 'I' }
    ]
  },
  {
    id: 51,
    question: "Generalmente he tenido…",
    interpretations: [
      { id: 'a', text: "Fuertes convicciones y un sentido de cómo deberían ser las cosas", value: 'D' },
      { id: 'b', text: "Serias dudas y me he cuestionado sobre cómo parecían ser las cosas", value: 'H' }
    ]
  },
  {
    id: 52,
    question: "He creado problemas con los demás por ser una persona…",
    interpretations: [
      { id: 'a', text: "Pesimista y quejumbrosa", value: 'B' },
      { id: 'b', text: "Autoritaria y controladora", value: 'G' }
    ]
  },
  {
    id: 53,
    question: "Típicamente me he inclinado por…",
    interpretations: [
      { id: 'a', text: "Dejarme llevar por mis emociones y que las piezas encajen donde deban", value: 'F' },
      { id: 'b', text: "No actuar según mis sentimientos para que no surjan más problemas", value: 'A' }
    ]
  },
  {
    id: 54,
    question: "Por lo general ser el centro de atención…",
    interpretations: [
      { id: 'a', text: "Me ha resultado natural", value: 'C' },
      { id: 'b', text: "Me ha resultado extraño", value: 'E' }
    ]
  },
  {
    id: 55,
    question: "He sido una persona…",
    interpretations: [
      { id: 'a', text: "Cuidadosa y he intentado anticiparme a los problemas", value: 'B' },
      { id: 'b', text: "Espontánea y he preferido improvisar cuando surgen los problemas", value: 'I' }
    ]
  },
  {
    id: 56,
    question: "Usualmente me he enfadado cuando otros…",
    interpretations: [
      { id: 'a', text: "No me han agradecido lo que he hecho por ellos", value: 'F' },
      { id: 'b', text: "No hacen caso a lo que les he dicho", value: 'D' }
    ]
  },
  {
    id: 57,
    question: "Ha sido importante para mí…",
    interpretations: [
      { id: 'a', text: "Ser independiente y autosuficiente", value: 'G' },
      { id: 'b', text: "Ser valorado y admirado", value: 'C' }
    ]
  },
  {
    id: 58,
    question: "Cuando he entrado en debate con amigos…",
    interpretations: [
      { id: 'a', text: "He insistido en mis argumentos con fuerza", value: 'H' },
      { id: 'b', text: "He dejado que las cosas sigan su curso para prevenir resentimientos", value: 'A' }
    ]
  },
  {
    id: 59,
    question: "Con frecuencia he…",
    interpretations: [
      { id: 'a', text: "Sido posesivo(a) con mis seres queridos", value: 'F' },
      { id: 'b', text: "He puesto a prueba a mis seres queridos para ver si realmente me aprecian", value: 'B' }
    ]
  },
  {
    id: 60,
    question: "Mi mayor fortaleza ha sido…",
    interpretations: [
      { id: 'a', text: "Organizar recursos y hacer que las cosas sucedan", value: 'G' },
      { id: 'b', text: "Dar nuevas ideas y que las personas se entusiasmen con ellas", value: 'I' }
    ]
  },
  {
    id: 61,
    question: "Me he inclinado por ser una persona…",
    interpretations: [
      { id: 'a', text: "Impulsiva y muy dura conmigo mismo(a)", value: 'D' },
      { id: 'b', text: "Demasiado emocional y bastante indisciplinada", value: 'E' }
    ]
  },
  {
    id: 62,
    question: "He tratado de mantener mi vida…",
    interpretations: [
      { id: 'a', text: "Acelerada, intensa y emocionante", value: 'I' },
      { id: 'b', text: "Normal, estable y pacífica", value: 'A' }
    ]
  },
  {
    id: 63,
    question: "Generalmente…",
    interpretations: [
      { id: 'a', text: "Cuando he tenido éxito he dudado de mis habilidades", value: 'B' },
      { id: 'b', text: "Cuando he tenido contratiempos he mantenido la confianza en mis habilidades", value: 'C' }
    ]
  },
  {
    id: 64,
    question: "Frecuentemente he tendido a…",
    interpretations: [
      { id: 'a', text: "Centrarme en mis sentimientos y a aferrarme a ellos durante mucho tiempo", value: 'E' },
      { id: 'b', text: "Minimizar mis sentimientos y a no prestarles mucha atención", value: 'H' }
    ]
  },
  {
    id: 65,
    question: "Casi siempre he brindado a muchas personas…",
    interpretations: [
      { id: 'a', text: "Atención y cariño", value: 'F' },
      { id: 'b', text: "Dirección y motivación", value: 'G' }
    ]
  },
  {
    id: 66,
    question: "He sido una persona…",
    interpretations: [
      { id: 'a', text: "Un poco seria y estricta conmigo mismo(a)", value: 'D' },
      { id: 'b', text: "Un poco libre y permisiva conmigo mismo(a)", value: 'I' }
    ]
  },
  {
    id: 67,
    question: "Generalmente he sido una persona…",
    interpretations: [
      { id: 'a', text: "Segura de sí misma y motivada para sobresalir", value: 'C' },
      { id: 'b', text: "Modesta y feliz de ir a mi propio ritmo", value: 'A' }
    ]
  },
  {
    id: 68,
    question: "He sentido orgullo por…",
    interpretations: [
      { id: 'a', text: "Mi claridad y objetividad", value: 'H' },
      { id: 'b', text: "Mi confiabilidad y compromiso", value: 'B' }
    ]
  },
  {
    id: 69,
    question: "Entender mis sentimientos ha sido…",
    interpretations: [
      { id: 'a', text: "Importante porque he necesitado entenderlos", value: 'E' },
      { id: 'b', text: "No ha sido mi prioridad, he preferido ocuparme de otras cosas", value: 'G' }
    ]
  },
  {
    id: 70,
    question: "Generalmente he pensado que soy una persona…",
    interpretations: [
      { id: 'a', text: "Animada y casual", value: 'A' },
      { id: 'b', text: "Seria y digna", value: 'D' }
    ]
  },
   {
    id: 71,
    question: "He tenido…",
    interpretations: [
      { id: 'a', text: "Una mente ágil y una energía ilimitada", value: 'I' },
      { id: 'b', text: "Un corazón bondadoso y una profunda dedicación", value: 'F' }
    ]
  },
  {
    id: 72,
    question: "He tenido tendencia a…",
    interpretations: [
      { id: 'a', text: "Perseguir actividades que me proporcionen recompensa y reconocimiento", value: 'C' },
      { id: 'b', text: "Hacer cosas que de verdad me interesen, no me interesa tanto la recompensa y el reconocimiento", value: 'H' }
    ]
  },
  {
    id: 73,
    question: "Usualmente…",
    interpretations: [
      { id: 'a', text: "No he tenido una vida social muy activa, no es mi prioridad", value: 'D' },
      { id: 'b', text: "Me he tomado mis obligaciones sociales muy en serio", value: 'B' }
    ]
  },
  {
    id: 74,
    question: "Casi siempre he preferido…",
    interpretations: [
      { id: 'a', text: "Asumir el liderazgo de las situaciones", value: 'G' },
      { id: 'b', text: "Dejar que otros asuman el liderazgo", value: 'A' }
    ]
  },
  {
    id: 75,
    question: "A través de los años mis valores y estilo de vida…",
    interpretations: [
      { id: 'a', text: "Han cambiado mucho", value: 'C' },
      { id: 'b', text: "Han permanecido casi igual", value: 'D' }
    ]
  },
  {
    id: 76,
    question: "Típicamente no he tenido…",
    interpretations: [
      { id: 'a', text: "Disciplina", value: 'I' },
      { id: 'b', text: "Conexión con las personas", value: 'H' }
    ]
  },
  {
    id: 77,
    question: "Me he inclinado hacia…",
    interpretations: [
      { id: 'a', text: "Retener mi afecto y he querido que otros vinieran a mi mundo", value: 'E' },
      { id: 'b', text: "Dar mi afecto con demasiada libertad y he querido extenderme a los demás", value: 'F' }
    ]
  },
  {
    id: 78,
    question: "He tenido la tendencia de pensar en…",
    interpretations: [
      { id: 'a', text: "Lo peor que podría pasar", value: 'B' },
      { id: 'b', text: "Que todo saldrá bien", value: 'A' }
    ]
  },
  {
    id: 79,
    question: "Las personas han confiado en mí porque…",
    interpretations: [
      { id: 'a', text: "Soy de confianza y puedo cuidar de ellas", value: 'G' },
      { id: 'b', text: "Soy una persona justa y haré lo correcto", value: 'D' }
    ]
  },
  {
    id: 80,
    question: "Con frecuencia…",
    interpretations: [
      { id: 'a', text: "Me he aislado de los demás para enfocarme en mis proyectos", value: 'H' },
      { id: 'b', text: "Me he enfocado en los demás y he ignorado mis proyectos", value: 'F' }
    ]
  },
   {
    id: 81,
    question: "Usualmente cuando he conocido a una persona nueva…",
    interpretations: [
      { id: 'a', text: "Me he mantenido equilibrado(a) y reservado(a)", value: 'C' },
      { id: 'b', text: "Me ha gustado ser divertido(a) y conversador(a)", value: 'I' }
    ]
  },
  {
    id: 82,
    question: "Generalmente he sido una persona…",
    interpretations: [
      { id: 'a', text: "Pesimista", value: 'E' },
      { id: 'b', text: "Optimista", value: 'A' }
    ]
  },
  {
    id: 83,
    question: "He preferido…",
    interpretations: [
      { id: 'a', text: "Habitar mi propio mundo", value: 'H' },
      { id: 'b', text: "Que el mundo sepa que estoy aquí", value: 'G' }
    ]
  },
  {
    id: 84,
    question: "Con frecuencia he tenido problemas con…",
    interpretations: [
      { id: 'a', text: "Mi nerviosismo, inseguridades y dudas", value: 'B' },
      { id: 'b', text: "Mi rabia, perfeccionismo e impaciencia", value: 'D' }
    ]
  },
  {
    id: 85,
    question: "Me doy cuenta de que a menudo he sido una persona…",
    interpretations: [
      { id: 'a', text: "Demasiado cercana", value: 'F' },
      { id: 'b', text: "Demasiado fría y distante", value: 'C' }
    ]
  },
  {
    id: 86,
    question: "He perdido porque…",
    interpretations: [
      { id: 'a', text: "No me he sentido con fuerzas para aprovechar las oportunidades", value: 'E' },
      { id: 'b', text: "He perseguido demasiadas posibilidades", value: 'I' }
    ]
  },
  {
    id: 87,
    question: "Generalmente…",
    interpretations: [
      { id: 'a', text: "He esperado mucho para entrar en acción", value: 'H' },
      { id: 'b', text: "He tomado acción rápidamente", value: 'D' }
    ]
  },
  {
    id: 88,
    question: "Cuando necesito tomar una decisión…",
    interpretations: [
      { id: 'a', text: "Usualmente he tenido dificultades para hacerlo", value: 'B' },
      { id: 'b', text: "Rara vez tengo dificultades", value: 'G' }
    ]
  },
  {
    id: 89,
    question: "He tenido la tendencia de…",
    interpretations: [
      { id: 'a', text: "Ser una persona demasiado agresiva con los demás", value: 'F' },
      { id: 'b', text: "No ser lo suficientemente firme con los demás", value: 'A' }
    ]
  },
  {
    id: 90,
    question: "Mi carácter ha sido por lo general…",
    interpretations: [
      { id: 'a', text: "Tranquilo", value: 'C' },
      { id: 'b', text: "Con fuertes cambios de humor", value: 'E' }
    ]
  },
   {
    id: 91,
    question: "Cuando no he sentido seguridad en lo que debo hacer…",
    interpretations: [
      { id: 'a', text: "Con frecuencia he buscado el consejo de otras personas", value: 'B' },
      { id: 'b', text: "He intentado diferentes cosas hasta encontrar la que funcione mejor", value: 'I' }
    ]
  },
  {
    id: 92,
    question: "Me ha preocupado…",
    interpretations: [
      { id: 'a', text: "Quedarme fuera de las actividades de los demás", value: 'F' },
      { id: 'b', text: "Que las actividades de los demás me distraigan", value: 'D' }
    ]
  },
  {
    id: 93,
    question: "Normalmente cuando me he enojado con alguien…",
    interpretations: [
      { id: 'a', text: "Le he llamado la atención", value: 'G' },
      { id: 'b', text: "Me he distanciado", value: 'C' }
    ]
  },
  {
    id: 94,
    question: "He tenido tendencia a…",
    interpretations: [
      { id: 'a', text: "Tener problemas para conciliar el sueño", value: 'H' },
      { id: 'b', text: "Conciliar el sueño fácilmente", value: 'A' }
    ]
  },
  {
    id: 95,
    question: "Con frecuencia he intentado averiguar…",
    interpretations: [
      { id: 'a', text: "Cómo acercarme a los demás", value: 'F' },
      { id: 'b', text: "Lo que otros quieren de mí", value: 'B' }
    ]
  },
  {
    id: 96,
    question: "Usualmente he sido una persona…",
    interpretations: [
      { id: 'a', text: "Mesurada, directa e intencional", value: 'G' },
      { id: 'b', text: "Excitable, que habla rápido e ingeniosa", value: 'I' }
    ]
  },
  {
    id: 97,
    question: "Con frecuencia he…",
    interpretations: [
      { id: 'a', text: "Evitado decirle a los demás que están cometiendo un error", value: 'E' },
      { id: 'b', text: "Ayudado a otros para que se den cuenta de que están cometiendo un error", value: 'D' }
    ]
  },
  {
    id: 98,
    question: "La mayor parte de mi vida he sido una persona…",
    interpretations: [
      { id: 'a', text: "Con muchos sentimientos volátiles", value: 'I' },
      { id: 'b', text: "Con sentimientos estables", value: 'A' }
    ]
  },
  {
    id: 99,
    question: "Cuando alguien no me cae bien me he inclinado por…",
    interpretations: [
      { id: 'a', text: "Ser cordial a pesar de mis sentimientos", value: 'C' },
      { id: 'b', text: "Hacérselo saber de alguna manera", value: 'B' }
    ]
  },
  {
    id: 100,
    question: "Muchas de las dificultades que he tenido con otras personas han surgido por…",
    interpretations: [
      { id: 'a', text: "Mi susceptibilidad y de tomarme todo demasiado a pecho", value: 'E' },
      { id: 'b', text: "Mi desinterés por las convenciones sociales", value: 'H' }
    ]
  },
  {
    id: 101,
    question: "Generalmente he…",
    interpretations: [
      { id: 'a', text: "Intervenido y rescatado a las personas", value: 'F' },
      { id: 'b', text: "Enseñado a las personas cómo ayudarse a sí mismas", value: 'G' }
    ]
  },
  {
    id: 102,
    question: "Normalmente…",
    interpretations: [
      { id: 'a', text: "He disfrutado de soltar y superar los límites", value: 'I' },
      { id: 'b', text: "No he disfrutado mucho de perder el control de mí mismo(a)", value: 'D' }
    ]
  },
  {
    id: 103,
    question: "Me he preocupado demasiado por…",
    interpretations: [
      { id: 'a', text: "Hacerlo mejor que los demás", value: 'C' },
      { id: 'b', text: "Hacer que las cosas estén bien para los demás", value: 'A' }
    ]
  },
  {
    id: 104,
    question: "Normalmente mis pensamientos han sido…",
    interpretations: [
      { id: 'a', text: "Especulativos, imaginativos y con curiosidad", value: 'H' },
      { id: 'b', text: "Prácticos, tratando de mantener las cosas en marcha", value: 'B' }
    ]
  },
  {
    id: 105,
    question: "Una de mis grandes fortalezas ha sido mi habilidad para…",
    interpretations: [
      { id: 'a', text: "Encargarme de las situaciones", value: 'G' },
      { id: 'b', text: "Describir estados emocionales", value: 'E' }
    ]
  },
  {
    id: 106,
    question: "Por lo general…",
    interpretations: [
      { id: 'a', text: "He presionado para que se hagan las cosas aunque incomode a las personas", value: 'D' },
      { id: 'b', text: "No me ha gustado sentirme presionado(a) y no me gusta presionar a nadie", value: 'A' }
    ]
  },
  {
    id: 107,
    question: "Con frecuencia he sentido orgullo por…",
    interpretations: [
      { id: 'a', text: "Lo importante que he sido en la vida de los demás", value: 'F' },
      { id: 'b', text: "Mi entusiasmo e iniciativa para vivir nuevas experiencias", value: 'I' }
    ]
  },
  {
    id: 108,
    question: "A menudo percibo que los demás me ven como una persona…",
    interpretations: [
      { id: 'a', text: "Con presencia y admirable", value: 'C' },
      { id: 'b', text: "Inusual y extraña", value: 'H' }
    ]
  },
  {
    id: 109,
    question: "He hecho en la mayoría de las ocasiones…",
    interpretations: [
      { id: 'a', text: "Lo que tenía que hacer", value: 'B' },
      { id: 'b', text: "Lo que quería hacer", value: 'E' }
    ]
  },
  {
    id: 110,
    question: "Ante situaciones difíciles y de mucha presión usualmente…",
    interpretations: [
      { id: 'a', text: "He disfrutado de ellas", value: 'G' },
      { id: 'b', text: "Me han desagradado", value: 'A' }
    ]
  },
   {
    id: 111,
    question: "He sentido orgullo por…",
    interpretations: [
      { id: 'a', text: "Mi habilidad de ser flexible", value: 'C' },
      { id: 'b', text: "Tener una postura firme e inamovible", value: 'D' }
    ]
  },
  {
    id: 112,
    question: "He tenido un estilo inclinado hacia…",
    interpretations: [
      { id: 'a', text: "La sobriedad y la austeridad", value: 'H' },
      { id: 'b', text: "El exceso y la exageración", value: 'I' }
    ]
  },
  {
    id: 113,
    question: "Con frecuencia…",
    interpretations: [
      { id: 'a', text: "Pospongo mi salud y bienestar por mi fuerte deseo de ayudar a los demás", value: 'F' },
      { id: 'b', text: "Mis relaciones han sufrido por mi fuerte deseo de priorizar mis necesidades", value: 'E' }
    ]
  },
  {
    id: 114,
    question: "Por lo general he sido una persona…",
    interpretations: [
      { id: 'a', text: "Abierta e ingenua", value: 'A' },
      { id: 'b', text: "Demasiado cautelosa y precavida", value: 'B' }
    ]
  },
  {
    id: 115,
    question: "Algunas veces he desanimado a las personas por ser…",
    interpretations: [
      { id: 'a', text: "Demasiado agresivo(a)", value: 'G' },
      { id: 'b', text: "Demasiado tenso(a)", value: 'D' }
    ]
  },
  {
    id: 116,
    question: "Para mí ha sido una prioridad importante…",
    interpretations: [
      { id: 'a', text: "Estar al servicio de los demás y atender sus necesidades", value: 'F' },
      { id: 'b', text: "Buscar alternativas para hacer las cosas", value: 'H' }
    ]
  },
  {
    id: 117,
    question: "Normalmente…",
    interpretations: [
      { id: 'a', text: "He sido constante y perseverante en la consecución de mis objetivos", value: 'C' },
      { id: 'b', text: "He preferido explorar distintos cursos de acción para ver a dónde me llevan", value: 'I' }
    ]
  },
  {
    id: 118,
    question: "Con frecuencia me han atraído situaciones…",
    interpretations: [
      { id: 'a', text: "Que despiertan emociones profundas e intensas", value: 'E' },
      { id: 'b', text: "Que me hacen sentir tranquilo(a) y relajado(a)", value: 'A' }
    ]
  },
  {
    id: 119,
    question: "Me he preocupado más por…",
    interpretations: [
      { id: 'a', text: "Perseguir mis intereses que por lograr resultados prácticos", value: 'H' },
      { id: 'b', text: "Ser práctico(a) y obtener resultados concretos", value: 'G' }
    ]
  },
  {
    id: 120,
    question: "He tenido una profunda necesidad de…",
    interpretations: [
      { id: 'a', text: "Pertenecer", value: 'B' },
      { id: 'b', text: "Sentir equilibrio", value: 'D' }
    ]
  },
  {
    id: 121,
    question: "Probablemente…",
    interpretations: [
      { id: 'a', text: "He insistido mucho en mantener la cercanía con mis amistades", value: 'F' },
      { id: 'b', text: "He estado muy distante de mis amistades", value: 'C' }
    ]
  },
  {
    id: 122,
    question: "Me he inclinado por:",
    interpretations: [
      { id: 'a', text: "Apegarme a pensamientos del pasado", value: 'E' },
      { id: 'b', text: "Anticiparme a lo que voy a hacer", value: 'I' }
    ]
  },
  {
    id: 123,
    question: "Generalmente he visto a los demás como:",
    interpretations: [
      { id: 'a', text: "Intrusivos y demandantes", value: 'H' },
      { id: 'b', text: "Desorganizados e irresponsables", value: 'D' }
    ]
  },
  {
    id: 124,
    question: "Usualmente…",
    interpretations: [
      { id: 'a', text: "No he confiado mucho en mí mismo(a)", value: 'B' },
      { id: 'b', text: "He confiado solo en mí mismo(a)", value: 'G' }
    ]
  },
  {
    id: 125,
    question: "He sido probablemente una persona…",
    interpretations: [
      { id: 'a', text: "Muy pasiva y que no se involucra", value: 'A' },
      { id: 'b', text: "Muy controladora y manipuladora", value: 'F' }
    ]
  },
  {
    id: 126,
    question: "Cuando tengo dudas…",
    interpretations: [
      { id: 'a', text: "Frecuentemente me detengo y dudo de mí mismo(a)", value: 'E' },
      { id: 'b', text: "Rara vez permito que mi desconfianza en mí se interponga", value: 'C' }
    ]
  },
  {
    id: 127,
    question: "Cuando he tenido que elegir…",
    interpretations: [
      { id: 'a', text: "Entre lo conocido y lo nuevo, elijo lo nuevo", value: 'I' },
      { id: 'b', text: "Me quedo con lo que ya conozco y me gusta", value: 'B' }
    ]
  },
  {
    id: 128,
    question: "Generalmente he sentido que…",
    interpretations: [
      { id: 'a', text: "Tener cercanía física con otros les reafirma lo que siento por ellos", value: 'F' },
      { id: 'b', text: "El amor verdadero no depende del contacto físico", value: 'D' }
    ]
  },
  {
    id: 129,
    question: "Cuando he tenido que confrontar a alguien…",
    interpretations: [
      { id: 'a', text: "He sido demasiado duro(a) y directo(a)", value: 'G' },
      { id: 'b', text: "He dado muchos rodeos", value: 'C' }
    ]
  },
  {
    id: 130,
    question: "Normalmente…",
    interpretations: [
      { id: 'a', text: "Me han atraído temas que los demás encontrarían inquietantes y amenazantes", value: 'H' },
      { id: 'b', text: "No me han atraído temas inquietantes y amenazantes", value: 'A' }
    ]
  },
  {
    id: 131,
    question: "He tenido dificultades con los demás por ser una persona…",
    interpretations: [
      { id: 'a', text: "Muy intrusiva", value: 'F' },
      { id: 'b', text: "Muy evasiva y que se comunica poco", value: 'B' }
    ]
  },
  {
    id: 132,
    question: "Me he preocupado por…",
    interpretations: [
      { id: 'a', text: "No tener los recursos para hacerme cargo de mis responsabilidades", value: 'G' },
      { id: 'b', text: "No tener la disciplina para enfocarme en lo que me satisface", value: 'I' }
    ]
  },
  {
    id: 133,
    question: "Generalmente he sido una persona…",
    interpretations: [
      { id: 'a', text: "Altamente intuitiva e individualista", value: 'E' },
      { id: 'b', text: "Altamente organizada y responsable", value: 'D' }
    ]
  },
  {
    id: 134,
    question: "Uno de mis principales obstáculos ha sido…",
    interpretations: [
      { id: 'a', text: "Superar la inercia", value: 'A' },
      { id: 'b', text: "Ser capaz de ir más despacio", value: 'I' }
    ]
  },
  {
    id: 135,
    question: "Cuando me he sentido inseguro(a) he reaccionado siendo…",
    interpretations: [
      { id: 'a', text: "Arrogante y despreciativo(a)", value: 'C' },
      { id: 'b', text: "Defensivo(a) y argumentativo(a)", value: 'B' }
    ]
  },
  {
    id: 136,
    question: "Normalmente…",
    interpretations: [
      { id: 'a', text: "He sido de mente abierta y de probar nuevos enfoques", value: 'H' },
      { id: 'b', text: "He sido una persona reveladora y de compartir mis emociones", value: 'E' }
    ]
  },
  {
    id: 137,
    question: "Con frecuencia me he presentado ante los demás…",
    interpretations: [
      { id: 'a', text: "Más fuerte de lo que realmente soy", value: 'G' },
      { id: 'b', text: "Más cariñoso(a) de lo que realmente soy", value: 'F' }
    ]
  },
  {
    id: 138,
    question: "Usualmente le he hecho más caso…",
    interpretations: [
      { id: 'a', text: "A mi conciencia y a mi razón", value: 'D' },
      { id: 'b', text: "A mis sentimientos e impulsos", value: 'I' }
    ]
  },
  {
    id: 139,
    question: "La fuerte adversidad me ha hecho sentir…",
    interpretations: [
      { id: 'a', text: "Endurecido(a) y resolutivo(a)", value: 'C' },
      { id: 'b', text: "Desanimado(a) y resignado(a)", value: 'A' }
    ]
  },
  {
    id: 140,
    question: "Me he inclinado por…",
    interpretations: [
      { id: 'a', text: "Asegurarme de tener una red de seguridad por si caigo", value: 'B' },
      { id: 'b', text: "Vivir al límite y depender de los demás lo menos posible", value: 'H' }
    ]
  },
  {
    id: 141,
    question: "Con frecuencia…",
    interpretations: [
      { id: 'a', text: "He sido fuerte para otros, pero no para enfrentar mis emociones", value: 'G' },
      { id: 'b', text: "Mis emociones me han impedido ser fuerte para los demás", value: 'E' }
    ]
  },
  {
    id: 142,
    question: "Con frecuencia me he preguntado…",
    interpretations: [
      { id: 'a', text: "Por qué las personas se enfocan en lo negativo cuando la vida es maravillosa", value: 'A' },
      { id: 'b', text: "Por qué las personas actúan siempre felices cuando hay tantos problemas", value: 'D' }
    ]
  },
  {
    id: 143,
    question: "He intentado mucho que no me vean como una persona…",
    interpretations: [
      { id: 'a', text: "Egoísta", value: 'F' },
      { id: 'b', text: "Aburrida", value: 'I' }
    ]
  },
  {
    id: 144,
    question: "He evitado la intimidad con los demás…",
    interpretations: [
      { id: 'a', text: "Cuando temo abrumarme con sus necesidades", value: 'H' },
      { id: 'b', text: "Cuando temo no estar a la altura de sus expectativas sobre mí", value: 'C' }
    ]
  },

];